import React, { useEffect, useState } from 'react'
import CMS from '../../../components/cms/CMS'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import PageBanner from '../../../components/general/PageBanner';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFormGroupGet } from '../../../redux/slices/formGroupGetSlice';
import CMSTable from '../../../components/general/CMSTable';
import { columns } from '../../../utilities/columns/formsColumns';
import CrudForms from './CrudForms';
import { fetchLanguageGetAll } from '../../../redux/slices/languageGetAllSlice';
import { fetchFormDelete } from '../../../redux/slices/formDeleteSlice';

const FormsPage = () => {
    const { t } = useTranslation()
    const { id } = useParams()
    const [changed, setChanged] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [modal, setModal] = useState(false)
    const [loading, setLoading] = useState(false);
    const lang = useSelector(state => state.lang.lang)
    const formGroup = useSelector(state => state.formGroupGet.data)
    const languages = useSelector(state => state.languageGetAll.data)
    const navigation = useNavigate()
    const dispatch = useDispatch()

    const getData = async () => {
        setLoading(true);
        await dispatch(fetchLanguageGetAll())
        await dispatch(fetchFormGroupGet({ id: id }))
        setChanged(false)
        setLoading(false);
    }

    const deleteData = async (id) => {
        await dispatch(fetchFormDelete({ id: id }))
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            {
                formGroup ? <>
                    <PageBanner
                        title={`${formGroup?.title[lang]} ${t("form_management")}`}
                        description={`${formGroup?.title[lang]} ${t("form_management_description")}`}
                        modal={modal}
                        setModal={setModal}
                        buttonText={t("form_add")}
                    />

                    <CMSTable
                        columns={columns({
                            t: t,
                            modal: modal,
                            setModal: setModal,
                            lang: lang,
                            deleteData: deleteData,
                            navigation: navigation,
                            setSelectedItem: setSelectedItem
                        })}
                        data={formGroup?.forms}
                        loading={loading}
                    />

                    <CrudForms
                        setChanged={setChanged}
                        showMenu={modal}
                        setShowMenu={setModal}
                        formGroupId={id}
                        languages={languages}
                        setSelectedItem={setSelectedItem}
                        selectedItem={selectedItem}
                        t={t}
                    />
                </> : null
            }
        </CMS>
    )
}

export default FormsPage
